// Gated downloads. Each capture writes a lead with source='download-<slug>'
// so we can see which guide draws which audience.

export const DOWNLOADS = [
  {
    slug: "pdpl-compliance-checklist",
    title: "PDPL Compliance Checklist",
    subtitle: "Every obligation, with a tick box and a 'who owns this' column.",
    description:
      "A working checklist across every article of the Oman PDPL and the executive regulations. Structured so you can walk through it with your DPO, your CTO and your general counsel in one session — with a column for who owns each item and what the evidence looks like.",
    fileHref: "#",
    bullets: [
      "Every article of the PDPL mapped to a concrete obligation",
      "'Who owns this' column so nothing falls between departments",
      "Evidence column so an auditor can be answered without a scramble",
      "Editable — Google Sheets and Excel versions in the same download",
    ],
  },
  {
    slug: "software-project-brief-template",
    title: "Software Project Brief Template",
    subtitle: "What to give any vendor so their quotes are comparable.",
    description:
      "The brief we ask every client for before we quote. Fill it out once and you can send the same document to three vendors and get quotes you can actually compare side by side — instead of three different documents describing three different projects.",
    fileHref: "#",
    bullets: [
      "The questions vendors ought to ask but usually do not",
      "Scope broken into must-have, should-have and later",
      "Space for constraints (budget, timing, data residency)",
      "A section for the things you are deliberately choosing not to build",
    ],
  },
  {
    slug: "delivery-platform-feature-checklist",
    title: "Delivery Platform Feature Checklist",
    subtitle: "60 features ranked as must-have, should-have, later.",
    description:
      "Written from the inside — the feature list we would give a new operator starting a delivery business in Oman today. Sixty items across customer app, driver app, dispatch, pricing, tracking, proof of delivery and shipper portal, with our honest recommendation on what belongs in day-one scope.",
    fileHref: "#",
    bullets: [
      "Customer app · Driver app · Dispatch · Pricing · Shipper portal",
      "Every feature ranked must-have / should-have / later",
      "Notes on the ones we would build differently now",
      "The features we have seen operators regret leaving out",
    ],
  },
];
